import { FCWithChildren } from '@types';
import React from 'react';

import { ToastProvider } from 'react-toast-notifications';

import { LayoutProvider } from '@contexts/LayoutContext';
import { BottomQuickSetupBar, Footer, Header, Toast } from '@components';
import classNames from 'classnames';
import useDeviceDetect from '@hooks/useDeviceDetect';

type LayoutProps = {
  admin?: boolean;
  isBoldynRoute?: boolean;
  logo?: string;
  publicRoute?: boolean;
  noHeader?: boolean;
  noFooter?: boolean;
};

const Layout: FCWithChildren<LayoutProps> = ({
  admin = false,
  children,
  isBoldynRoute = true,
  publicRoute = false,
  noHeader = false,
  noFooter = false,
}) => {
  const { isMobile } = useDeviceDetect();

  return (
    <LayoutProvider isBoldynRoute={isBoldynRoute} publicRoute={publicRoute}>
      <ToastProvider autoDismiss autoDismissTimeout={5000} components={{ Toast }}>
        <section
          className={classNames('w-full min-h-screen flex flex-col font-sans', {
            'overflow-hidden': isMobile,
          })}
        >
          {!noHeader && (
            <Header admin={admin} isBoldynRoute={isBoldynRoute} publicRoute={publicRoute} />
          )}
          <main
            className={classNames('px-4 sm:px-6 lg:px-40 xl:px-40', {
              'pb-24 sm:pb-28': admin || noFooter,
            })}
            aria-label="body-container"
            id="main-content"
          >
            {children}
          </main>
          {!admin && !noFooter && <Footer />}
        </section>
        <BottomQuickSetupBar />
      </ToastProvider>
    </LayoutProvider>
  );
};

export default Layout;
